import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Marketplace from "./components/Marketplace";
import Incentives from "./components/Incentives";
import CustomNavbar from "./components/Navbar";
import ListingPage from "./components/ListingPage";
import CommonApp from "./components/CommonApp";
import Vendors from "./components/Vendors";
import SimpleFooter from "./components/SimpleFooter";
import CommunitySolar from "./components/CommunitySolar";

function App() {
  return (
    <Router>
      <CustomNavbar></CustomNavbar>

      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route exact path="/marketplace" element={<Marketplace />}></Route>
        <Route exact path="/incentives" element={<Incentives />}></Route>
        <Route exact path="/commonapp" element={<CommonApp />}></Route>
        <Route exact path="/listings/:id" element={<ListingPage />}></Route>
        <Route exact path="/vendors" element={<Vendors />}></Route>
        <Route
          exact
          path="/communitysolar"
          element={<CommunitySolar />}
        ></Route>
      </Routes>

      <div className="App"></div>
      <SimpleFooter></SimpleFooter>
    </Router>
  );
}

export default App;
